import { createContext } from 'react';

const ExerciseTranslationsContext = createContext({
    exerciseDialog: {
        buttons: {
            pause: '',
        },
        loading: '',
        calculating: '',
    },
    exerciseResumeDialog: {
        title: '',
        message: {
            p1: {
                restartable: '',
                nonRestartable: '',
            },
            p2: '',
        },
        result: '',
        scorePrefix: '',
        buttons: {
            resume: '',
            restart: '',
            cancel: '',
        },
    },
    exerciseRestartDialog: {
        title: '',
        message: {
            p1: {
                restartable: '',
                nonRestartable: '',
            },
        },
        result: '',
        scorePrefix: '',
        buttons: {
            restart: '',
            cancel: '',
            review: '',
        },
    },
    exercisePauseDialog: {
        title: '',
        message: {
            p1: '',
            p2: '',
        },
        buttons: {
            continue: '',
            pause: '',
        },
    },
    assignmentExpiredDialog: {
        title: '',
        message: '',
        buttons: {
            close: '',
        },
    },
    exerciseResultState: {
        title: '',
        messages: {
            veryGood: '',
            wellDone: '',
            bad: '',
            showScore: {
                result: '',
                perfectResult: '',
            },
        },
        buttons: {
            restart: '',
            close: '',
            review: '',
        },
    },
    exercisePausedState: {
        title: '',
        messages: {
            veryGood: '',
            wellDone: '',
            bad: '',
            incomplete: '',
        },
        buttons: {
            close: '',
        },
        showScore: {
            title: '',
        },
    },
    exerciseFailedState: {
        message: '',
        buttons: {
            close: '',
            retry: '',
        },
    },
    closeDialog: '',
    loading: '',
    generalNode: '',
    serviceNotAvailable: {
        title: '',
        p1: '',
        p2: '',
    },
    progressionBar: {
        pending: '',
    },
});

export { ExerciseTranslationsContext };
